import { createSelector, createFeatureSelector } from '@ngrx/store';
import { PageState } from '@models/index';

export const pageSelector = createFeatureSelector<PageState>('page');
export const getPageSelector = createSelector(pageSelector, (state: PageState) => state);
export const getTitleSelector = createSelector(pageSelector, (state: PageState) => state.breadcrum[state.breadcrum.length - 1]);
export const getBreadcrumSelector = createSelector(pageSelector, (state: PageState) => state.breadcrum);
export const getPageURLSelector = createSelector(pageSelector, (state: PageState) => state.pageURL);
export const getDatePickerOptionsSelector = createSelector(pageSelector, (state: PageState) => state.datePickerOptions);
export const getLanguageSelector = createSelector(pageSelector, (state: PageState) => state.language);
export const getNotificationSelector = createSelector(pageSelector, (state: PageState) => state.notification);
export const getHelpSelector = createSelector(pageSelector, (state: PageState) => state.help);
export const getUserTypeListSelector = createSelector(pageSelector, (state: PageState) => state.userTypes.data);
export const getCommissionsSelector = createSelector(pageSelector, (state: PageState) => state.commissions);
